import { Box, Grid , Typography} from "@mui/material"
import { ThreeDots } from "../modal/ThreeDots";
import { useState} from "react"
import { FileInfo } from "../modal/FileInfo";

export const TBody = ({ ctgyData, handleUpdate,handleRemove,}) => {
    const [open,setOpen] = useState (false)
    const [selecId, setSelectId] = useState (null)
    const [isLoading, setIsLoading] = useState(true)
    const handleMOpen =()=>{
        setOpen(true);
        setIsLoading(true)
        const timer = setTimeout(() => setIsLoading(false), 2000);
            return () => clearTimeout(timer);
    }

    return (
        <Box height="100%" width="100%" display="flex" flexDirection="column" gap="12px" className="overflowY">
            {
                ctgyData.data.map((v,k) => (
                    <Box key={k} width="100%"  border="1px solid #EBEBEB" bgcolor="#FFFFFF" display='block' p='15px 0px 8px 20px' fontWeight={400}  >
                        <Grid container  display="flex"  >   
                            <Grid item xs={10} onClick={(e)=>{e.stopPropagation();setSelectId(v);handleMOpen()}}>
                                <Box display={'row'} justifyContent={'space-between'}  >
                                    <Box sx={{display:'flex', justifyContent:'space-between'}}>
                                        <Typography fontWeight={600} sx={{ fontSize:'12px',textAlign:'right', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap', color:'#11783C' }}>{v.category_number}</Typography>
                                        <Box display="flex" alignItems="center" textAlign="rigth" justifyContent="center" bgcolor={v.active === 1 ? '#00be811f' : '#E4E5E6'} color={v.active === 1 ? '#00be81' : '#7B7F82'} borderRadius="16px" px={1} >
                                            <Box sx={{height:'auto', fontSize:'12px'}}>{v.active === 1 ? 'Active' : 'Inactive'}</Box>
                                        </Box>
                                    </Box>
                                        <Typography sx={{ fontSize:'12px',textAlign:'left' }} fontWeight={600}>Name of Category:</Typography>
                                        <Typography sx={{ fontSize:'12px',textAlign:'left', wordBreak:'break-word'}}>{v.name}</Typography>
                                        <Typography sx={{ fontSize:'12px',textAlign:'left'}} fontWeight={600}>Type of Concern:</Typography>
                                        <Typography sx={{ fontSize:'12px',textAlign:'left', wordBreak:'break-word'}}>{v.type === 1 ? 'Suggestion/Recommendation' : 'Concern'}</Typography>
                                </Box>
                            </Grid>
                                <Grid item xs={2}>
                                    <Box display='flex' justifyContent="center" alignItems='center' height='100%'> 
                                        <ThreeDots ctgyData={ctgyData} handleUpdate={handleUpdate} v={v} handleRemove= {handleRemove} handleMOpen={handleMOpen} isLoading={isLoading}/>
                                    </Box>
                                </Grid>
                        </Grid>
                            <FileInfo  onClose={()=> setOpen(false)} v={selecId} open={open} isLoading={isLoading}/>
                    </Box>
                ))
            }
        </Box>
    )
}